import { Link, useLocation } from "react-router-dom";
import { Mail, Lock, Hammer } from "lucide-react";
import StripeBadge from "@/components/StripeBadge";

const LINKS = {
  Explore: [
    ["Browse items", "/browse"],
    ["How it works", "/how-it-works"],
    ["List an item", "/create"],
  ],
  Company: [
    ["About us", "/about"],
    ["FAQs", "/faq"],
    ["Contact", "/contact"],
    ["Owner Protection", "/owner-protection"],
    ["Marketplace Policy", "/policy"],
  ],
};

export default function Footer() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return null;

  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white mt-auto">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-xl bg-[#FF5A00] flex items-center justify-center">
                <Hammer className="w-5 h-5 text-white" />
              </div>
              <span className="font-display text-lg font-bold tracking-tight">SelLend</span>
            </Link>
            <p className="text-white/60 text-sm mt-5 leading-relaxed max-w-sm">
              SelLend exists to make ownership optional. We help people earn from the things they own and access the things they need—simply, securely, and affordably.
            </p>
            <a href="mailto:support@sellend.com" data-testid="footer-email" className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-[#FF5A00] transition-colors mt-5">
              <Mail className="w-4 h-4" /> support@sellend.com
            </a>
            <div className="mt-6 flex items-center gap-2 bg-white/5 border border-white/10 rounded-full pl-3 pr-4 py-2 w-fit">
              <Lock className="w-3.5 h-3.5 text-[#2E7D32]" />
              <StripeBadge variant="dark" />
            </div>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {Object.entries(LINKS).map(([title, items]) => (
              <div key={title}>
                <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-white/40 mb-4">{title}</h4>
                <ul className="space-y-3">
                  {items.map(([label, to]) => (
                    <li key={label}>
                      <Link
                        to={to}
                        data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                        className="text-sm text-white/70 hover:text-white transition-colors"
                      >
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} SelLend. Ireland's marketplace to rent, buy &amp; sell.</p>
          <div className="flex items-center gap-5">
            <Link to="/about" className="text-xs text-white/50 hover:text-white transition-colors">About</Link>
            <Link to="/faq" className="text-xs text-white/50 hover:text-white transition-colors">FAQs</Link>
            <Link to="/contact" className="text-xs text-white/50 hover:text-white transition-colors">Contact</Link>
            <Link to="/policy" className="text-xs text-white/50 hover:text-white transition-colors">Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
